const increasePetitionCount = async () => {
  const response = await fetch('https://letitryed.com/wp-json/petition/v1/count', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Petition-Token': '34c5806eb2fd5531f7b8df90c7a6df46b45ca157d06a2b1dd2f930c2ca49205f',
    },
  });
  console.log(response);
}

const fetchCountAndUpdate = async () => {
    const { count } = await fetch('https://letitryed.com/wp-json/petition/v1/count')
    .then(r => r.json()).catch(error => {
        throw new Error('Unable to fetch count', error);
    });

    console.log(count);

    return count;
}